/**
 * GrupoTemplate — CRUD da entidade Grupo + ação "Sincronizar Permissões".
 *
 * Copiado de hay-hotspot/assets/reactweb/src/pages/Auth/Grupo/GrupoTemplate.js (Fase 3.2) —
 * 100% genérico, sem mudanças.
 */
import React, { Component } from 'react';
import { confirmDialog } from 'primereact/confirmdialog';
import { TabPanel } from 'primereact/tabview';

import { TabViewComErro } from 'hay-core-react';
import { EntityGrid } from 'hay-core-react';
import { ModelTextInput } from 'hay-core-react';
import { ModelBoolean } from 'hay-core-react';
import { UtilService } from 'hay-core-react';
import Grupo from '../../../models/Grupo';
import { buildRelacionados } from '../../../service/RotasService';

function buildModel(mostrarAcessoTotal) {
  return {
    nome: { exibir: 'main.grupo.nome', visivel: true, validacao: { obrigatorio: true } },
    descricao: { exibir: 'main.grupo.descricao', visivel: true },
    ...(mostrarAcessoTotal ? {
      acessototal: { exibir: 'main.grupo.acessototal', visivel: true, tipo: 'boolean', template: 'acessototal.template', hidegrid: false, fixar: true, largura: '4rem' },
    } : {}),
    acessoinicial: { exibir: 'main.grupo.acessoinicial', visivel: true, tipo: 'boolean', template: 'acessoinicial.template', hidegrid: false, fixar: true, largura: '4rem' },
  };
}

const booleanTemplate = (campo) => (rowData) => (
  <i className={`pi ${rowData[campo] ? 'pi-check text-green-500' : 'pi-times text-red-400'}`}></i>
);

const renderers = {
  acessototal: { template: booleanTemplate('acessototal') },
  acessoinicial: { template: booleanTemplate('acessoinicial') },
};

class GrupoFormulario extends Component {
  render() {
    const { model, contexto } = this.props;
    const larguraAcessoInicial = model.acessototal ? 'md:col-3' : 'md:col-6';
    return (
      <TabViewComErro tentativaSalvar={contexto.state.tentativaSalvar} className="col-12 mt-2">
        <TabPanel header={UtilService.traduzir('main.grupo.aba.informacoesbasicas')} leftIcon="pi pi-info-circle mr-2">
          <div className="grid w-full">
            <div className="field col-12 md:col-6 mt-3"><ModelTextInput model={model.nome} contexto={contexto} /></div>
            {model.acessototal && (
              <div className="field col-12 md:col-3 mt-3"><ModelBoolean model={model.acessototal} contexto={contexto} /></div>
            )}
            <div className={`field col-12 ${larguraAcessoInicial} mt-3`}><ModelBoolean model={model.acessoinicial} contexto={contexto} /></div>
            <div className="field col-12 mt-3"><ModelTextInput model={model.descricao} contexto={contexto} /></div>
          </div>
        </TabPanel>
      </TabViewComErro>
    );
  }
}

class GrupoTemplate extends Component {

  processos() {
    const { permissoes } = this.props;
    const t = (chave) => UtilService.traduzir(chave);

    const podeSincronizar = permissoes?.grupo?.processos?.some(
      e => e.state === 'main.grupo.sincronizarpermissoes' && e.permitido
    );

    const lista = [];

    if (podeSincronizar) {
      lista.push({
        label: 'main.grupo.sincronizarpermissoes',
        icon: 'pi pi-sync',
        command: () => {
          confirmDialog({
            header: t('main.grupo.sincronizarpermissoes.header'),
            message: t('main.grupo.sincronizarpermissoes.mensagem'),
            icon: 'pi pi-exclamation-triangle',
            className: 'w-4',
            draggable: false,
            defaultFocus: 'reject',
            acceptClassName: 'p-button-warning',
            accept: async () => {
              try {
                await Grupo.sincronizarPermissoes();
                UtilService.showToast({ severity: 'success', summary: t('main.grupo.sincronizarpermissoes.sucesso') });
              } catch {
                UtilService.showToast({ severity: 'error', summary: t('main.grupo.sincronizarpermissoes.erro') });
              }
            },
          });
        },
      });
    }

    return lista;
  }

  render() {
    const model = buildModel(!!this.props.permissoes?.permiteacessogeral);
    return (
      <EntityGrid
        ref={(ref) => this.gridRef = ref}
        entidade={Grupo}
        model={model}
        identidade="main.grupo"
        permissoes={this.props.permissoes}
        icone="pi-tags"
        storageKey="dt-grupos"
        processos={this.processos()}
        getRelacionados={(selected) => buildRelacionados('grupo', this.props.permissoes, this.props.navigate, () => selected?.[0])}
        renderers={renderers}
        configuracao={this.props.configuracao}
        navigate={this.props.navigate}
        location={this.props.location}
        searchparams={this.props.searchparams}
        formulario={(m, ctx) => <GrupoFormulario model={m} contexto={ctx} />}
      />
    );
  }
}

export default GrupoTemplate;
